
import { Component, Vue, Watch } from 'vue-property-decorator'
import UIkit from 'uikit'

import BacHeaderWithMenue from '@/templates/BacHeaderWithMenue.vue'
import BacHeader from '@/templates/BacHeader.vue'

import ShareButton from '@/components/ShareButton.vue'
import BacCustomers from '@/components/teamsite/BacCustomers.vue'
import BacButton from '@/components/BacButton.vue'
import BacEditableImage from '@/components/BacEditableImage.vue'
import BacPrefixedInput from '@/components/BacPrefixedInput.vue'
// import BacInstagramWidget from '@/components/BacInstagramWidget.vue'
import BacMultiselectWrapper from '@/components/BacMultiselectWrapper.vue'
import VehicleComponent from '@/components/teamsite/VehicleComponent.vue'
import Charity from '@/components/teamsite/Charity.vue'
import Multiselect from 'vue-multiselect'
import BacEditableMinioImage from '@/components/BacEditableMinioImage.vue'

import { Rally } from '@/lib/models/Rally'
import { RallyRound } from '@/lib/models/RallyRound'
import { Team } from '@/lib/models/Team'
import { Vehicle } from '@/lib/models/Vehicle'
import { SerializationHelper } from '../lib/utils/SerializationHelper'
import { CustomerRegister } from '../lib/models/CustomerRegister'
import { Http } from '@/lib/utils/Http'
import { MinioRessource } from '@/lib/models/MinioRessource'

@Component({
  components: {
    BacHeaderWithMenue,
    BacHeader,
    ShareButton,
    BacCustomers,
    BacButton,
    BacEditableImage,
    BacPrefixedInput,
    //    BacInstagramWidget,
    BacMultiselectWrapper,
    Multiselect,
    VehicleComponent,
    Charity,
    BacEditableMinioImage
  }
})
export default class Teamsite extends Vue {
  vehicle: Vehicle = new Vehicle();
  queryString = window.location.search;
  urlParams = new URLSearchParams(this.queryString);

  teamId = this.$route.params.teamId ?? parseInt(this.urlParams.get('tid') ?? '0');

  saveDataJson = {};

  userChosenEditMode = true; // in edit mode per default

  headerBackgroundImage = '';

  providedRallyRoundVehicle: Vehicle|null = null

  teamLogo: MinioRessource = new MinioRessource()
  rallyRoundDefaultTeamLogo: MinioRessource = new MinioRessource()

  get teamLogoPath () {
    if (this.teamLogo && this.teamLogo.path) {
      return this.teamLogo.path
    }
    return this.rallyRoundDefaultTeamLogo.path
  }

  get hasEditPermission () {
    if (!this.loggedInUser) {
      return false
    }

    if (!this.team || !this.team.members || !this.team.members.length) {
      return false
    }

    return this.team.members.find(member => {
      return member.id === this.loggedInUser.id
    }) !== undefined
  }

  get editMode (): boolean {
    return this.hasEditPermission && this.userChosenEditMode
  }

  @Watch('rallyRound')
  onRallyRoundChanged () {
    this.loadHeaderBackgroundImage()
    this.loadProvidedVehicle()
    this.loadDefaultTeamLogo()
    if (this.$store.state.PageURLRallyRound.rallyRound.rallyId) {
      this.$store.dispatch('loadRally', this.$store.state.PageURLRallyRound.rallyRound.rallyId)
    }
  }

  @Watch('rallyRound')
  async loadDefaultTeamLogo () {
    if (this.rallyRound.defaultTeamLogoId) {
      this.rallyRoundDefaultTeamLogo = await MinioRessource.get(this.rallyRound.defaultTeamLogoId)
    }
  }

  @Watch('team')
  onTeamChanged () {
    this.loadHeaderBackgroundImage()
    this.addVehicleLoading = false
  }

  @Watch('rallyRound')
  public loadHeaderBackgroundImage () {
    this.headerBackgroundImage = this.team.headerImage
      ? (this.team as any).headerImage
      : this.rallyRound.headerImage ? this.rallyRound.headerImage.image : ''
  }

  /**
   * This function is called whenever a user input (e.g. from a textbox) is changed.
   * The data is debounced (no change happens for a certain period of time) the save function is called
   */
  saveTimeout = 0;
  inputChanged () {
    if (this.saveTimeout) {
      clearTimeout(this.saveTimeout)
    }
    this.saveTimeout = setTimeout(this.save, 1000)
  }

  async headerImageSuccessfulSave () {
    this.$store.dispatch('forceLoadTeam', this.$route.params.teamId)
  }

  async teamLogoSuccessfulSave () {
    this.$store.dispatch('forceLoadTeam', this.$route.params.teamId)
  }

  async teamLogoSaved (data: any) {
    if (!this.editMode || !this.team.id) {
      // not edit mode, no data has been changed, maybe something has been fetched in the background
      return
    }
    this.team.logoId = data.id
    await this.team.update()
    this.$store.dispatch('forceLoadTeam', this.$route.params.teamId)
    this.loadTeam()
  }

  async teamLogoDelete () {
    if (!this.editMode || !this.team.id) {
      // not edit mode, no data has been changed, maybe something has been fetched in the background
      return
    }
    this.team.logoId = null
    this.teamLogo.path = null
    await this.team.update()
    this.$store.dispatch('forceLoadTeam', this.$route.params.teamId)
    this.loadTeam()
  }

  async save (showConfirmation = true) {
    if (!this.editMode || !this.team.id) {
      // not edit mode, no data has been changed, maybe something has been fetched in the background
      return
    }
    try {
      const success = await this.team.update()

      if (this.team.id) {
        // update team name in customer register
        CustomerRegister.updateFromTeamId(this.team.id, {
          teamname: this.team.name,
          teamdescription: this.team.description
        })
      }

      if (!success) {
        throw new Error('an unknown error happened while updating!')
      }
      if (success && showConfirmation) {
        this.showSavedNotification()
      }
    } catch (ex) {
      console.error(ex)
      UIkit.notification({
        message:
          'Daten nicht gespeichert, etwas ging schief! Bitte kontaktiere uns sollte das Problem bestehen bleiben!',
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
    }
  }

  // don't show first notification where content is only updated cause loaded
  firstNotificationShowed = false
  lastShownNotification = new Date()
  showSavedNotification () {
    if (new Date().getTime() - this.lastShownNotification.getTime() < 1000) {
      return
    }
    this.lastShownNotification = new Date()
    if (!this.firstNotificationShowed) {
      this.firstNotificationShowed = true
      return
    }
    UIkit.notification({
      message: 'Daten gespeichert!',
      status: 'success',
      timeout: 1000,
      pos: 'bottom-center'
    })
  }

  setHeaderOffset () {
    const headers = document.getElementsByTagName('header')
    if (!headers.length) {

    }
    if (this.$refs.content && (this.$refs.content as []).length) {
      (this.$refs.content as HTMLElement[]).forEach(element => {
        element.style.paddingTop = headers[0].getClientRects()[0].height + 'px'
      })
    } else if (this.$refs.content) {
      (this.$refs.content as HTMLElement).style.paddingTop = headers[0].getClientRects()[0].height + 'px'
    }
  }

  mounted () {
    this.loadVehicle()
    this.loadHeaderBackgroundImage()
    this.loadProvidedVehicle()

    this.headerBackgroundImage = ''

    if (this.$store.state.PageURLRallyRound.rallyRound.rallyId) {
      this.$store.dispatch('loadRally', this.$store.state.PageURLRallyRound.rallyRound.rallyId)
    }

    if (this.$route.params.teamId) {
      this.$store.dispatch('loadTeam', this.$route.params.teamId)
    } else {
      this.$store.dispatch('loadTeam')
    }

    if (this.$route.params.rallyRoundId) {
      this.$store.dispatch('loadRallyRound', this.$route.params.rallyRoundId)
    } else {
      this.$store.dispatch('loadRallyRound')
    }

    this.$store.dispatch('loadLoggedInUser')

    setInterval(this.setHeaderOffset, 500)
    this.setHeaderOffset()

    this.loadCustomerRegister()
  }

  isCar = true
  async loadCustomerRegister () {
    if (!this.team || !this.team.id) {
      return
    }

    const customerRegisterId = parseInt((localStorage.getItem('registerStateLink') || '').replace('/register-state/', ''))
    if (!customerRegisterId) {
      console.warn('no customer register id found, defaulting to car')
      this.isCar = true // default to car, cause no customer register means usually you don't want to add vehicles (isCar is only used for that, be careful)
      return
    }

    const customerRegister = await CustomerRegister.get(customerRegisterId)
    this.isCar = customerRegister.teamType === 1
  }

  get loggedInUser () {
    return this.$store.state.LoggedInUser.user
  }

  get rally (): Rally {
    return this.$store.state.PageURLRally.rally
  }

  get rallyRound (): RallyRound {
    return this.$store.state.PageURLRallyRound.rallyRound
  }

  get team (): Team {
    return this.$store.state.PageURLTeam.team
  }

  @Watch('team')
  onTeamChange () {
    this.loadTeam()
    this.$store.dispatch('loadRallyRound', this.team.rallyRoundId)
  }

  async loadProvidedVehicle () {
    if (!this.rallyRound.providedVehicleId) {
      return
    }
    this.providedRallyRoundVehicle = await Vehicle.get(this.rallyRound.providedVehicleId)
  }

  async loadTeam () {
    if (this.team.logoId) {
      this.teamLogo = await MinioRessource.get(this.team.logoId)
    }
    this.loadCustomerRegister()
  }

  private async loadVehicle () {
    this.vehicle = SerializationHelper.toInstance(
      new Vehicle(),
      await (await Http.request(`/api/team/${this.teamId}/vehicle/`)).json()
    )
  }

  get instagramLink () {
    if (!this.team || !this.team.instagram) {
      return ''
    }
    return this.team.instagram.startsWith('http') ? this.team.instagram : `https://instagram.com/${this.team.instagram}`
  }

  get facebookLink () {
    if (!this.team || !this.team.facebook) {
      return ''
    }
    return this.team.facebook.startsWith('http') ? this.team.facebook : `https://facebook.com/${this.team.facebook}`
  }

  get twitterLink () {
    if (!this.team || !this.team.twitter) {
      return ''
    }
    return this.team.twitter.startsWith('http') ? this.team.twitter : `https://twitter.com/${this.team.twitter}`
  }

  get tiktokLink () {
    if (!this.team || !this.team.tiktok) {
      return ''
    }
    return this.team.tiktok.startsWith('http') ? this.team.twitter : `https://www.tiktok.com/@${this.team.tiktok}`
  }

  addVehicleLoading = false
  async addVehicle () {
    if (this.addVehicleLoading) {
      return
    }
    this.addVehicleLoading = true
    if (!this.team) {
      return
    }
    const vehicle = new Vehicle()
    vehicle.teamId = this.team.id
    await vehicle.create()
    if (this.team && this.team.vehicles) {
      /* this.team.vehicles.push(
        vehicle
      ) */
      this.$store.dispatch('loadTeam', this.$route.params.teamId)
    }
  }
}
